import { queryOptions } from '@tanstack/react-query';

import { FIVE_MINUTES } from '@/constants/time';
import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type MessageTemplatesV2 = NonNullable<
  paths['/v2/message-templates']['get']['responses'][200]['content']['application/json']['data']
>;

/**
 * Fetch the canned support messages from the v2 API.
 *
 * The endpoint answers 403 unless the caller may send support messages, so
 * callers should only enable the query for Primum staff.
 */
export async function getMessageTemplatesV2() {
  const { data } = await fetchClient.GET('/v2/message-templates');

  return data?.data;
}

/**
 * React Query options for the message templates.
 *
 * Templates change rarely, so a 5-minute stale time is used. Retries are off
 * because the only common failure is a 403 that a retry cannot fix, and the
 * caller falls back to the feature flag value or the bundled templates anyway.
 */
export function getMessageTemplatesV2QueryOptions(userId: string | undefined, enabled: boolean) {
  return queryOptions({
    queryKey: ['messageTemplatesV2', userId],
    queryFn: () => getMessageTemplatesV2(),
    staleTime: FIVE_MINUTES,
    retry: false,
    enabled,
  });
}
